module.exports = __webpack_public_path__ + "media/images/badge-nomad-4a445675eae2b4453209cfcc61caf52b.png";